import { render, staticRenderFns } from "./first-registration.vue?vue&type=template&id=7e2673a5&scoped=true&"
import script from "./first-registration.vue?vue&type=script&lang=js&"
export * from "./first-registration.vue?vue&type=script&lang=js&"
import style0 from "./first-registration.vue?vue&type=style&index=0&id=7e2673a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2673a5",
  null
  
)

export default component.exports